import type { VisibilityState } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTableViewOptions } from "@/components/custom/table/hooks/use-table-view-options";
import { createUserSourceColumns } from "./columns";

const USER_SOURCES_VISIBILITY_STORAGE_KEY =
  "user-sources-table-column-visibility-v1";

type UserSourcesViewOptionsProps = {
  onVisibilityChange?: (
    visibility: VisibilityState,
    setter: (
      value: VisibilityState | ((val: VisibilityState) => VisibilityState)
    ) => void
  ) => void;
};

type UserSourcesViewOptionsReturn = {
  columnVisibility: VisibilityState;
  setColumnVisibility: (
    value: VisibilityState | ((val: VisibilityState) => VisibilityState)
  ) => void;
  component: React.ReactElement;
};

export const useUserSourcesViewOptions = ({
  onVisibilityChange,
}: UserSourcesViewOptionsProps = {}): UserSourcesViewOptionsReturn => {
  // View options only reads `meta` (displayName/defaultVisible) — cells aren't rendered, so gateway props aren't needed.
  const columns = useMemo(() => createUserSourceColumns(), []);

  return useTableViewOptions({
    columns,
    storageKey: USER_SOURCES_VISIBILITY_STORAGE_KEY,
    onVisibilityChange,
    label: "Columns",
    className: "h-9 px-3 gap-2",
  });
};
